const secondsToHMS = (secs) => {
  function zvalue(n) { return (n < 10 ? '0' : '') + n; }
  let sign = secs < 0 ? '-' : '';
  let seconds = Math.abs(secs);
  return sign + Math.floor(zvalue(seconds / 3600 || 0)) + ':'
   + Math.floor(zvalue((seconds % 3600) / 60 || 0)) + ':' + zvalue(seconds % 60);
};

const hmsToSeconds = (tempTime) => {
  let timeValue = tempTime.split(':');
  return timeValue[0] * 3600 + timeValue[1] * 60 + (+timeValue[2] || 0);
};

const convertTo24h = (timeStr) => {
  let time = timeStr.match(/(\d+):(\d+):(\d+) (\w)/);
  let hr = Number(time[1]);
  let mins = Number(time[2]);
  let seconds = Number(time[3]);
  let meridian = time[4].toLowerCase();
  let result;

  if (meridian === 'p' && hr < 12) {
    hr += 12;
  } else if (meridian === 'a' && hr === 12) {
    hr -= 12;
  }
  result = hr + ':' + mins + ':' + seconds;
  return result;
};

const helpers = {
  convertToDays: (timeToExpiration) => {
    return Math.floor(timeToExpiration / (1000 * 60 * 60 * 24));
  },
  convertToHours: (timeToExpiration) => {
    return Math.floor((timeToExpiration / (1000 * 60 * 60)) % 24);
  },
  convertToMinutes: (timeToExpiration) => {
    return Math.floor((timeToExpiration / 1000 / 60) % 60);
  },
  convertToSeconds: (timeToExpiration) => {
    return Math.floor((timeToExpiration / 1000) % 60);
  },
  calculateSbotdTimeLeft: () => {
    const usaTimeZone = new Date().toLocaleString('en-US', { timeZone: 'America/Anchorage' });
    const usaTime = usaTimeZone.split(',');
    const currentTime = usaTime[1];

    const convertedTime = convertTo24h(currentTime);
    const dayEndTime = '22:59:59';
    const endTime = secondsToHMS(hmsToSeconds(dayEndTime) - hmsToSeconds(convertedTime));

    const promotionEnd = endTime.split(':');
    const hrs = promotionEnd[0] + 'hr ';
    const mins = promotionEnd[1] + 'min ';
    const sec = promotionEnd[2] + 'sec';
    const timeLeft = hrs + mins + sec;
    return timeLeft;
  },
  calculatePromotionTimeLeft: (promotionEndTime) => {
    let timeLeft = {};
    let currentTime = new Date().toLocaleString('en-US', { timeZone: 'America/Anchorage' });
    currentTime = new Date(currentTime);
    const timeToExpiration = +new Date(promotionEndTime) - currentTime;

    if (timeToExpiration > 0) {
      timeLeft = {
        days: helpers.convertToDays(timeToExpiration),
        hours: helpers.convertToHours(timeToExpiration),
        minutes: helpers.convertToMinutes(timeToExpiration),
        seconds: helpers.convertToSeconds(timeToExpiration),
        totalMilliseconds: timeToExpiration
      };
    }
    if (timeToExpiration <= 0) {
      timeLeft = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        totalMilliseconds: 0
      };
    }

    return timeLeft;
  }
};

export default helpers;
